import {
  Component,
  OnInit,
  forwardRef,
  Input,
  ViewChild,
  ElementRef,
  Output,
  EventEmitter,
  SimpleChanges,
  OnChanges,
  AfterViewChecked,
} from '@angular/core';
import {
  AbstractControl,
  ControlValueAccessor,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
  ValidationErrors,
} from '@angular/forms';
import {
  NgbDate,
  NgbDateStruct,
  NgbDatepickerI18n,
  NgbDateParserFormatter,
  NgbDatepicker,
} from '@ng-bootstrap/ng-bootstrap';
import { DateUtil } from '../utils/classes/DateUtil';
import { I18n, CustomDatepickerI18n } from '../config/CustomDatePickerI18n';
import { CustomDatepickerFormat } from '../config/CustomDatePickerFormat';
import { SharedComponentsUtil } from '../utils/classes/SharedComponentsUtil';
import { MessageUtilService } from '../utils/service/message-util.service';
import { DatePickerService } from './date-picker.service';

@Component({
  selector: 'date-picker',
  templateUrl: './date-picker.component.html',
  styleUrls: ['./date-picker.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => DatePickerComponent),
      multi: true,
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => DatePickerComponent),
      multi: true,
    },
    I18n,
    { provide: NgbDatepickerI18n, useClass: CustomDatepickerI18n },
    { provide: NgbDateParserFormatter, useClass: CustomDatepickerFormat },
  ],
})

// providers: [I18n, { provide: NgbDatepickerI18n, useClass: CustomDatepickerI18n }, { provide: NgbDateParserFormatter, useClass: CustomDatepickerFormat }]
export class DatePickerComponent
  implements OnInit, OnChanges, ControlValueAccessor
{
  @Input() showLabel: boolean = true;
  @Input() label: any = null;
  @Input() autocomplete: string = 'off';
  @Input() next: any;
  @Input() nextIsDisable: any;
  @Input() back: any;
  @Input() backIsDisable: any;
  @Input() required: boolean = false;
  @Input() noAutoCompleteNull: boolean = true;
  @Input() readonly: boolean = false;
  @Input() validatorMessage: boolean = false;
  @Input() tooltipMessage: boolean = true;
  @Input() validatorAlert: boolean = false;
  @Input() submitted: boolean = true;
  @Input() minDate!: NgbDateStruct;
  @Input() maxDate!: NgbDateStruct;
  @Input() invalid: boolean = false;
  @Input() focusInitial: boolean = false;
  @Input() disabled = false;
  @Output() onNext: EventEmitter<any> = new EventEmitter();
  @Output() onBack: EventEmitter<any> = new EventEmitter();
  @Output() input: EventEmitter<any> = new EventEmitter();
  @Output() onchange: EventEmitter<any> = new EventEmitter();
  @Output() blur: EventEmitter<any> = new EventEmitter();
  // xminDate = null;
  // xmaxDate = null;
  value: any;
  controls: any;
  fecha: DateUtil = new DateUtil();
  emitValue: NgbDate | string = '';
  sharedComponentsUtil = new SharedComponentsUtil();
  @ViewChild('fecha') ngbDatepicker: NgbDatepicker | any;

  constructor(
    private el: ElementRef,
    private messageUtilService: MessageUtilService,
    private datePickerService: DatePickerService
  ) {
    this.showLabel = this.datePickerService.getShowLabel();
    this.autocomplete = this.datePickerService.getAutocomplete();
    this.noAutoCompleteNull = this.datePickerService.getNoAutoCompleteNull();
    this.focusInitial = this.datePickerService.getFocusInitial();
    this.validatorMessage = this.datePickerService.getValidatorMessage();
    this.tooltipMessage = this.datePickerService.getTooltipMessage();
    this.submitted = this.datePickerService.getSubmitted();
    this.validatorAlert = this.datePickerService.getValidatorAlert();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.submitted) {
      if (this.controls !== undefined && changes.submitted.currentValue) {
        this.controls.markAsDirty();
        this.controls.markAsTouched();
      }
    }
  }

  ngOnInit() {
    if (this.minDate) {
      this.minDate = this.strDateToNgbDate(this.minDate);
    }
    if (this.focusInitial == true && this.disabled == false) {
      const invalidControl =
        this.el.nativeElement.querySelector('[type="text"]');
      invalidControl.focus();
      invalidControl.select();
    }
  }

  onChange = (_: any) => {};
  onValidationChange = () => {};
  onTouch = () => {};

  focus = () => {
    const invalidControl = this.el.nativeElement.querySelector('[type="text"]');
    invalidControl.focus();
    invalidControl.select();
  };

  onFocus(evt: any) {
    if (evt) {
      const invalidControl =
        this.el.nativeElement.querySelector('[type="text"]');
      invalidControl.select();
    }
  }

  writeValue(value: any): void {
    if (value) {
      this.value = this.strDateToNgbDate(value) || '';
    } else {
      this.value = '';
    }
  }
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }
  setDisabledState?(isDisabled: boolean = false): void {
    this.disabled = isDisabled;
  }

  validate(control: AbstractControl): ValidationErrors | any {
    this.controls = control;
    return null;
  }

  registerOnValidatorChange?(fn: () => void): void {
    this.onValidationChange = fn;
  }

  onBlur(value: any) {
    this.onTouch();
    // if (value && value !== '') {
    //   console.log(value);
    //   this.onValidationChange();
    //   this.blur.emit(value);
    // }
  }

  onInput(value: any) {
    this.emitValue = value;
    this.value = value;
    if (this.value instanceof NgbDate) {
      this.emitValue = this.ngbDatetoString(value);
    }
    this.onTouch();
    this.onChange(this.emitValue);
    this.onchange.emit(this.emitValue);
    this.input.emit(this.emitValue);
  }
  onKeyUpEnter(value: any) {
    if (this.value instanceof NgbDate) {
      if (value !== this.ngbDatetoString(this.value)) {
        this.emitValue = this.ngbDatetoString(value);
      } else {
        this.emitValue = value;
      }
    } else {
      value = value.replaceAll('/', '');
      if (this.noAutoCompleteNull) {
        this.value = this.strDateToNgbDate(this.fecha.dateAutoComplete(value));
        this.emitValue = this.fecha.dateAutoComplete(value);
      } else {
        if (value != '' && value != null) {
          this.value = this.strDateToNgbDate(
            this.fecha.dateAutoComplete(value)
          );
          this.emitValue = this.fecha.dateAutoComplete(value);
        }
      }
    }

    this.enterKeyUp();
    this.onTouch();
    this.onChange(this.emitValue);
  }

  onlyNumbers(e: any) {
    if (!(e.keyCode >= 48 && e.keyCode <= 57) && e.keyCode != 47) {
      e.preventDefault();
      e.stopPropagation();
    }
  }

  strDateToNgbDate(value: any) {
    const date: Date = this.fecha.strToDate(value);
    const ngbDate: NgbDateStruct = {
      day: Number(this.fecha.getDayFromDate(date)),
      month: Number(this.fecha.getMonthFromDate(date)),
      year: Number(this.fecha.getYearFromDate(date)),
    };
    // return ngbDate;
    return new NgbDate(ngbDate.year, ngbDate.month, ngbDate.day);
  }
  ngbDatetoString(value: NgbDateStruct): NgbDate | string {
    const concatNgbDate =
      `0${value.day}`.slice(-2) + `0${value.month}`.slice(-2) + value.year;
    return this.fecha.dateAutoComplete(concatNgbDate);
  }

  enterKeyUp() {
    if (!this.disabled) {
      let validator = this.sharedComponentsUtil.stopByValidator(
        this.controls,
        this.validatorAlert,
        this.label
      );
      if (validator.error) {
        this.messageUtilService.getMessageError(
          '000046',
          'Error',
          validator.message
        );
        return;
      }
    }
    if (this.next != undefined) {
      if (this.next.disabled || this.next.readonly) {
        if (this.nextIsDisable != undefined) {
          this.nextIsDisable.focus();
        }
      } else {
        this.next.focus();
      }
    } else {
      if (this.nextIsDisable != undefined) {
        this.nextIsDisable.focus();
      } else {
        this.onNext.emit();
      }
    }
  }

  arrowUpKeyUp() {
    if (!this.disabled) {
      let validator = this.sharedComponentsUtil.stopByValidator(
        this.controls,
        this.validatorAlert,
        this.label
      );
      if (validator.error) {
        this.messageUtilService.getMessageError(
          '000046',
          'Error',
          validator.message
        );
        return;
      }
    }
    if (this.back != undefined) {
      if (this.back.disabled || this.back.readonly) {
        if (this.backIsDisable != undefined) {
          this.backIsDisable.focus();
        }
      } else {
        this.back.focus();
      }
    } else {
      if (this.backIsDisable != undefined) {
        this.backIsDisable.focus();
      } else {
        this.onBack.emit();
      }
    }
  }

  focusOut(value: any) {
    if (value && value !== '') {
      this.ngbDatepicker.close();
      if (value instanceof NgbDate) {
        if (value !== this.ngbDatetoString(value)) {
          this.emitValue = this.ngbDatetoString(value);
        } else {
          this.emitValue = value;
        }
      } else {
        value = value.replaceAll('/', '');
        if (this.noAutoCompleteNull) {
          this.value = this.strDateToNgbDate(
            this.fecha.dateAutoComplete(value)
          );
          this.emitValue = this.fecha.dateAutoComplete(value);
        } else {
          if (value != '' && value != null) {
            this.value = this.strDateToNgbDate(
              this.fecha.dateAutoComplete(value)
            );
            this.emitValue = this.fecha.dateAutoComplete(value);
          }
        }
      }
      this.onTouch();
      this.onChange(this.emitValue);
    }
  }
}
